import { setLocalStorage, getLocalStorage, setSessionStorage, getSessionStorage } from 'mazey';
import { enName } from '../config/page-settings';

export function wSetLocalStorage (key, value) {
  return setLocalStorage(`${enName}_${key}`, value);
}

export function wGetLocalStorage (key) {
  return getLocalStorage(`${enName}_${key}`);
}

export function wSetSessionStorage (key, value) {
  return setSessionStorage(`${enName}_${key}`, value);
}

export function wGetSessionStorage (key) {
  return getSessionStorage(`${enName}_${key}`);
}
